<template>
    <div class="vh-100">
        <h1>Font Favorites</h1>

        <div class="d-flex my-3">
            <div class="mx-1">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="Show all"
                       v-model="currentFilter">
                <label class="form-check-label" for="exampleRadios1">
                    Show all
                </label>
            </div>

            <div class="mx-1">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="sans-serif"
                       v-model="currentFilter">
                <label class="form-check-label" for="exampleRadios2">
                    Sans Serif
                </label>
            </div>

            <div class="mx-1">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="serif"
                       v-model="currentFilter">
                <label class="form-check-label" for="exampleRadios2">
                    Serif
                </label>
            </div>

            <div class="mx-1">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="display"
                       v-model="currentFilter">
                <label class="form-check-label" for="exampleRadios2">
                    Display
                </label>
            </div>

            <div class="mx-1">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2"
                       value="handwriting"
                       v-model="currentFilter">
                <label class="form-check-label" for="exampleRadios2">
                    Hand writing
                </label>
            </div>

            <div class="mx-1">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="monospace"
                       v-model="currentFilter">
                <label class="form-check-label" for="exampleRadios2">
                    Monospace
                </label>
            </div>
        </div>

        <div class="row h-100">
            <div class="col-3 h-100">
                <h3>Fonts ({{ filteredFonts.length }})</h3>
                <div class="list-group" style="height: calc(100% - 120px); overflow-y: scroll">
                    <a v-for="(font, index) in filteredFonts" href="javascript:void(0)"
                       @click="onFontClick(font)"
                       class="list-group-item list-group-item-action pointer">
                        {{ index + 1 }}. {{ font.family }}
                    </a>
                </div>
            </div>
            <div class="col-6">
                <h3>{{ currentFont.family }}</h3>

                <div class="ms-2 mt-2" style="font-size: 40px;" :style="newFontStyle">
                    Very important text.
                </div>

                <div v-if="isFavorite">
                    Favorite

                    <div>
                        <button class="btn btn-danger" @click="onRemoveClick">Remove from Favorites</button>
                    </div>

                </div>
                <div v-else>
                    <div>
                        <button class="btn btn-primary" @click="onFavoriteClick">Favorite</button>
                    </div>
                </div>

            </div>

            <div class="col-3 h-100">
                <div class="d-flex">
                    <h3>Favorites ({{ favorites.length }})</h3>

                    <div class="ms-2">
                        <button class="btn btn-primary" @click="onPrintClick">Print to Console</button>
                    </div>
                </div>

                <div class="list-group" style="height: calc(100% - 120px); overflow-y: scroll">
                    <a v-for="font in favorites" href="javascript:void(0)"
                       @click="onFontClick(font)"
                       class="list-group-item list-group-item-action pointer">
                        {{ font.family }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ResourcesService from "./services/ResourcesService";

export default {
    name: 'FontFavoritesApp',
    computed: {
        loading() {
            return this.model.loading
        },
        filteredFonts() {

            if (this.currentFilter === 'Show all') {
                return this.model.fonts
            }
            return this.model.fonts.filter((font) => {
                return font.category === this.currentFilter
            })
        },
        isFavorite() {
            if (this.currentFont.family) {
                return this.favorites.filter((font) => {
                    return font.family === this.currentFont.family
                }).length > 0
            }

            return false
        },
        newFontStyle() {
            if (this.currentFont.family) {
                return {
                    fontFamily: this.currentFont.family
                }
            }

            return {
                fontFamily: 'Raleway'
            }
        }
    },
    data() {
        return {
            model: webase.model,
            currentFilter: 'Show all',
            currentFont: {
                family: ''
            },
            favorites: [],
            picks: ['Roboto',
                'Open Sans',
                'Lato',
                'Oswald',
                'Roboto Condensed',
                'Slabo',
                'Montserrat',
                'Source Sans Pro',
                'Raleway',
                'PT Sans',
                'Open Sans Condensed',
                'Roboto Slab',
                'Merriweather',
                'Lora',
                'Ubuntu',
                'Noto Sans',
                'Playfair Display',
                'Poppins',
                'PT Sans Narrow',
                'PT Serif',
                'Arimo',
                'Roboto Mono',
                'Titillium Web',
                'Muli',
                'Nunito',
                'Baskerville',
                'Cabin',
                'Alfa Slab One',
                'Bellota',
                'Codystar',
                'Copse'
            ],
            webaseFonts: []
        }
    },
    mounted() {
        let resourcesService = new ResourcesService()
        let url = webase.utils.app.getBaseUrl() + '/resources/fonts.json?t=' + Date.now()
        resourcesService.get(url).then((response) => {
            this.model.fonts = response.items
            this.initPicks()
            this.categorizeFonts()
        })

        if (window.localStorage.getItem('WEBASE_FONT_FAVORITES')) {
            let fontFavorites = window.localStorage.getItem('WEBASE_FONT_FAVORITES')
            this.favorites = JSON.parse(fontFavorites)
        }
    },
    methods: {
        onFontClick(font) {
            this.currentFont = font
            let url = 'https://fonts.googleapis.com/css?family=' + font.family + ':400'
            let link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            document.getElementsByTagName("head")[0].appendChild(link);
        },
        onFavoriteClick() {
            if (this.currentFont.family && !this.isFavorite) {
                this.favorites.push(this.currentFont)
                window.localStorage.setItem('WEBASE_FONT_FAVORITES', JSON.stringify(this.favorites))
            }
        },
        onPrintClick() {
            console.log(this.favorites)
        },
        onRemoveClick() {

            for (let i = 0; i < this.favorites.length; i++) {

                if (this.favorites[i].family === this.currentFont.family) {
                    this.favorites.splice(i, 1)
                    window.localStorage.setItem('WEBASE_FONT_FAVORITES', JSON.stringify(this.favorites))
                    return
                }
            }
        },

        categorizeFonts() {
            let fontMap = {}

            for (let j = 0; j < this.model.fonts.length; j++) {
                let category = this.model.fonts[j].category

                if (fontMap[category] === undefined) {
                    fontMap[category] = 0
                }

                fontMap[category] += 1
            }

            console.log('category count')
            console.log(fontMap)
        },

        initPicks() {
            for (let i = 0; i < this.picks.length; i++) {

                for (let j = 0; j < this.model.fonts.length; j++) {
                    if (this.model.fonts[j].family === this.picks[i]) {

                        this.webaseFonts.push(this.model.fonts[j])
                        break;
                    }
                }
            }

            this.webaseFonts.sort(function (a, b) {
                let nameA = a.family.toUpperCase(); // ignore upper and lowercase
                let nameB = b.family.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            });

            console.log('Webase fonts')
            console.log(JSON.stringify(this.webaseFonts))

        }
    }
}
</script>